import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import customIsoString from "utilities/custom-iso-string";
import "./InputHomework.module.scss";

/**
 * Import components
 */
import HomeworkBar from "components/UI/SubjectBar/SubjectBar";
import Subject from "components/UI/Subject/Subject";

import InputHomeworkForm from "./components/InputHomeworkForm";

/**
 * Import FontAwesome
 */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

/**
 * Import actions
 */
import {
    homeworkDescription,
    homeworkNote,
    homeworkDate,
    homeworkSubject,
    homeworkType,
    homeworkMark,
    homeworkImage,
    homeworkReset,
    homeworkTimeslot
} from "actions/new-homework";
import homeworkStore from "actions/homework/store";
import homeworkUpdate from "actions/homework/update";
import destroyEvent from "actions/event/destroy";

import taskStore from "actions/task/store";

import getScheduleByDay from "selectors/schedule/day";

const mapStateToProps = (state, props) => {
    return {
        homework: state.new_homework,
        subjects: state.user_subject.entities,
        colors: state.color.entities,
        schedule: state.authentication.user.schedule,
        user: state.authentication.user,
        auth: state.authentication,
        events: state.event,
        plannedHomework: state.homework.entities
    };
};

const mapDispatchToProps = {
    homeworkDescription,
    homeworkNote,
    homeworkDate,
    homeworkSubject,
    homeworkType,
    homeworkMark,
    homeworkImage,
    homeworkStore,
    homeworkUpdate,
    homeworkReset,
    homeworkTimeslot,
    destroyEvent,
    taskStore
};

const valueFromId = (opts, id) => opts.find(o => o.value === id);

class InputHomework extends Component {
    constructor() {
        super();

        this.state = {
            day: "",
            month: "",
            year: "",
            showTip: false
        };

        this.handleDescriptionUpdate = this.handleDescriptionUpdate.bind(this);
        this.handleNoteUpdate = this.handleNoteUpdate.bind(this);
        this.handleTypeChange = this.handleTypeChange.bind(this);
        this.handleMarkChange = this.handleMarkChange.bind(this);
        this.storeHomework = this.storeHomework.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.deleteImage = this.deleteImage.bind(this);
        this.onImageChange = this.onImageChange.bind(this);
        this.toggleTip = this.toggleTip.bind(this);
        this.openImage = this.openImage.bind(this);
        this.destroyItem = this.destroyItem.bind(this);
    }

    componentDidMount() {
        if (this.props.subjects.allIds.length < 2) {
            //user always has the Other Task subject so if it is 0 (should not happen) or 1 (only Other Task), show alert

            alert(
                "Je hebt nog geen vakken in je rooster, huiswerk plannen niet mogelijk."
            );
            this.props.handleClose();
        }

        if (
            !this.props.homework.subject &&
            this.props.subjects.allIds.length > 1
        ) {
            this.props.homeworkSubject(this.props.subjects.allIds[1]);
        }
        if (this.props.homework.editing) {
            this.setState({ imagePreviewUrl: this.props.homework.image });
        }
    }

    handleDescriptionUpdate(event) {
        this.props.homeworkDescription(event.target.value);
    }

    handleNoteUpdate(event) {
        this.props.homeworkNote(event.target.value);
    }

    handleTypeChange(event) {
        this.props.homeworkType(event.target.value);
    }

    handleMarkChange() {
        this.props.homeworkMark(!this.props.homework.mark);
    }

    onImageChange(e) {
        const files = Array.from(e.target.files);
        if (files.length < 1) {
            return;
        }

        const image = files[0];
        let reader = new FileReader();

        reader.onloadend = () => {
            this.setState({
                imagePreviewUrl: reader.result
            });
            this.props.homeworkImage(image);
        };

        reader.readAsDataURL(image);
    }

    deleteImage() {
        this.setState({
            imagePreviewUrl: null
        });
        this.props.homeworkImage(null);
    }

    handleClose(event) {
        this.props.handleClose(event);
        this.props.homeworkReset();
    }

    toggleTip() {
        this.setState({ showTip: !this.state.showTip });
    }

    storeHomework() {
        if (this.props.homework.editing) {
            this.props.homeworkUpdate(this.props.homework).then(result => {
                this.props.handleClose();
                this.props.homeworkReset();
            });
        } else {
            this.props.homeworkStore(this.props.homework).then(result => {
                this.props.handleClose();

                if (this.props.homework.directlyCreateTask) {
                    this.props.taskStore({
                        name: this.props.homework.description,
                        time: 10,
                        order: 1,
                        homework_id: result.id,
                        status: "not_started"
                    });
                }

                this.props.homeworkReset();
            });
        }
    }

    openImage(data) {
        var image = new Image();
        image.src = data;
        var w = window.open("");
        w.document.write(image.outerHTML);
    }

    destroyItem(type) {
        if (confirm("Weet je zeker dat je dit agenda item wilt verwijderen?")) {
            let data = {};
            if (this.props.homework.event.isRecurring) {
                let date = new Date(this.props.homework.date);

                data = {
                    id: this.props.homework.event.id,
                    redit: type,
                    origid: this.props.homework.event.origid,
                    ristart: customIsoString(date, true),
                    startDateUtc: customIsoString(date, true)
                };
            } else {
                data = {
                    id: this.props.homework.event.id,
                    redit: ""
                };
            }

            this.props
                .destroyEvent(data.id, data)
                .then(() => this.props.handleClose());
        }
    }

    render() {
        const months = [
            "januari",
            "februari",
            "maart",
            "april",
            "mei",
            "juni",
            "juli",
            "augustus",
            "september",
            "oktober",
            "november",
            " december"
        ];

        let days = [];

        for (let index = 1; index <= 31; index++) {
            days.push(
                <option key={index} value={index}>
                    {index}
                </option>
            );
        }

        let date = new Date(this.props.homework.date);

        let subjectId = null;
        if (this.props.homework.editing) {
            subjectId = this.props.homework.user_subject_id;
        } else {
            subjectId = this.props.homework.subject;
        }

        let subject = this.props.subjects.byId[subjectId];
        let abbreviation = "";
        let color = null;
        if (subject && subject.color_id) {
            color =
                this.props.colors.byId &&
                this.props.colors.byId[subject.color_id];
            color = color && color.color;
        }
        if (subject && subject.subject_abbreviation) {
            abbreviation = subject.subject_abbreviation;
        }

        return (
            <div styleName="input-content">
                <h1 styleName="title">{`Huiswerk ${
                    this.props.homework.editing ? "wijzigen" : "invoeren"
                }`}</h1>
                <div styleName="card-content">
                    <HomeworkBar
                        homework={this.props.homework}
                        date={date}
                        handleSubjectEditClick={
                            this.props.handleSubjectEditClick
                        }
                        handleDetailsEditClick={
                            this.props.handleDetailsEditClick
                        }
                        isRecurring={this.props.homework.event.isRecurring}
                        destroyItem={this.destroyItem}
                        color={color}
                        abbreviation={abbreviation}
                        new={this.props.homework.editing}
                    />

                    <InputHomeworkForm editing={this.props.homework.editing} />

                    <div styleName="buttons">
                        <p onClick={this.handleClose}>Annuleer</p>
                        <p onClick={this.storeHomework} styleName={"save"}>
                            {this.props.homework.editing
                                ? "Bijwerken"
                                : "Opslaan"}
                        </p>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(InputHomework);
